import React, { useEffect, useState } from 'react'
import { Box, Button, FormControl, InputLabel, ListItem, TextField, Typography } from '@mui/material'
import { ApiGetCategoryList } from '../../../apiService/Core/Apicall.tsx'
import { useNavigate } from 'react-router-dom'
import edit from '../../../assets/images/editIcon.png'



function Categorylist() {

    const [CategoryList, setCategoryList] = useState<any[]>([])
    const [search, setsearch] = useState<string>('')
    const [filterItems, setfilterItems] = useState<any[]>([])

    const navigate = useNavigate()


    useEffect(() => {
        const getCategoryList = async () => {
            const response = await ApiGetCategoryList()
            setCategoryList(response.data)
        }
        getCategoryList()
    }, [])

    useEffect(() => {
        if (CategoryList) {
            const filteredCategories = CategoryList.filter(category =>
                category.categoryName.toLowerCase().includes(search.toLowerCase())
            );
            setfilterItems(filteredCategories)
        }
    }, [search, CategoryList])

    return (
        <Box className='container-fluid p-3 extra' bgcolor='white' minHeight='calc(100vh - 180px)'>
            <Box className='d-flex mb-3 align-items-center justify-content-between'>
                <Typography className='fw-bold' variant='h4'>Category List</Typography>
                <Button variant="contained" onClick={() => { navigate('/admin/others/add-or-upate-category') }} className="table-row-background my-1" sx={{ width: 'fit-content', textTransform: 'none' }}>Add Category</Button>
            </Box>
            <FormControl className='my-3 mt-4 col-12'>
                <InputLabel>Search Category</InputLabel>
                <TextField
                    value={search}
                    onChange={(e) => { setsearch(e.target.value) }}
                />
            </FormControl>
            <Box className='d-flex align-items-center flex-wrap justify-content-between'>
                {filterItems && filterItems.map((item: any, index: number) => (
                    <Box width='33%' key={index} className='p-3 mt-2' sx={{ border: '1px solid #0000001A', borderRadius: '10px' }}>
                        <Box className=' d-flex justify-content-between align-items-center gap-1'>
                            <Box className='col-11 d-flex align-items-center mb-1 justify-content-between'>
                                <Typography className='fw-bold' variant='h6'>{item?.categoryName}</Typography>
                                <Typography className='fw-bold' variant='h6'>{item?.categoryWeightage}</Typography>
                            </Box>
                            <Box  sx={{width:'5%', cursor: 'pointer' }} onClick={() => { navigate(`/admin/others/add-or-upate-category`, { state: { questionData: item } }) }} component='img' src={edit} />
                        </Box>
                        <Box className='d-flex align-items-center mt-2' gap={2}>
                            <Box component='img' src={item?.mmUrl} height='48px' width='48px' border='1px solid #0000001A' borderRadius='5px' />
                            <Box component='img' src={item?.transportUrl} height='48px' width='48px' border='1px solid #0000001A' borderRadius='5px' />
                            <Box component='img' src={item?.bloomsUrl} height='48px' width='48px' border='1px solid #0000001A' borderRadius='5px' />
                            <Box component='img' src={item?.aldiUrl} height='48px' width='48px' border='1px solid #0000001A' borderRadius='5px' />
                        </Box>
                    </Box>
                ))}
            </Box>

        </Box>

    )
}

export default Categorylist
